import React from 'react';
import {classes, style} from './doppe-action-type-widget-content-date.st.css';
import {DoppeHideableValue, doppeHideableValueIsHidden} from "../../client-server-common/types/doppe-hideable-value";
import {DateTimeValue} from "@wix/devzai-utils-common";

export const DoppeActionTypeWidgetContentDate = React.memo(function DoppeActionTypeWidgetInnerTitle (props: DoppeActionTypeWidgetInnerTitle.Props) {
    const {
        children,

        className,
        ...htmlAttributes
    } = props;


    if (doppeHideableValueIsHidden(children)) {
        return null;
    }

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
        >
            {new Date(children).toDateString()}
        </div>
    );
});

export namespace DoppeActionTypeWidgetInnerTitle {

    export interface Props extends React.HTMLAttributes<any> {
        children: DoppeHideableValue<DateTimeValue>;
    }
}
